<template lang="pug">
  .event__item
    .item__main
      span.main__time {{ componentData.time_begin }} - {{ componentData.time_end }}
      h4.main__title {{ componentData.discipline }}
      span.main__type(v-if="componentData.type_workload") {{ componentData.type_workload }}
      .main__groups(v-if="componentData.groups && componentData.groups.length")
        span.main__group(v-for="item in sortedGroups(componentData.groups)" :key="item.group") {{ item.group }}
      span.main__room(v-if="componentData.room") {{ componentData.room }}
      span.main__teacher {{ componentData.teacher }}

    .item__footer(v-if="!componentData.room")
      a.footer__link(target="blank" :href="setLink(componentData)")
        | Перейти к событию
        v-icon(name="arrow")
      a.footer__link(
        v-if="componentData.hrefList && componentData.hrefList.presentation"
        target="blank"
        :href="componentData.hrefList.presentation"
      )
        | Скачать презентацию
        v-icon(name="download")
</template>

<script>
  export default {
    props:{
      componentData: {
        type: Object,
        default: () => ({})
      }
    },

    methods: {
      setLink(data) {
        if (data.token) return data.hrefList?.webinar;
        if (data.record) return data.record;
        return data.href;
      },
      sortedGroups(groups) {
        if (!groups) return [];
        return [...groups].sort((a, b) => a.group.localeCompare(b.group));
      },
    },
  }
</script>

<style lang="scss">
.event__item {
  min-width: 24rem;
  max-width: 24.4rem;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 5px 9px rgba(75, 90, 202, 0.3);
  background-color: #4b5aca;
  color: white;

  & + .modal-window__btn-close {
    position: absolute;
    top: 5px;
    right: 5px;
    background-color: #000;
    border-radius: 5px;
    border: none;
    color: $basic-white;
  }

  .item__main {
    color: inherit;
    display: grid;
    row-gap: 0.5rem;
    padding: 10px 8px 1.1rem 8px;
  }

  .main__group,
  .main__room,
  .main__teacher,
  .main__type,
  .task-list__item,
  .main__title,
  .main__time {
    color: inherit;
  }

  .main__title {
    margin-top: 8px;
  }

  .task-list__item {
    list-style: disc;
    font-size: 12px;
  }

  .main__teacher {
    font-size: 12px;
  }

  .main__groups {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .main__group,
  .main__room {
    font-size: 12px;
  }

  .main__type {
    font-size: 12px;
    opacity: 0.8;
  }

  .main__title {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 5px;
    text-transform: uppercase;
  }

  .main__time {
    font-weight: bold;
  }

  .item__footer {
    background-color: $basic-white;
  }

  .footer__link {
    padding: 8px 10px;
    color: $basic-black;
    font-weight: bold;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .m-icon--download {
    width: 18px;
  }

  .m-icon--arrow {
    width: 18px;
    transform: rotate(180deg);
  }

}
.event__item + .m-button {
  right: 5px !important;
  top: 5px !important;
  background-color: $basic-black !important;
}
</style>
